// function common header crm links
// Helper function to check user permissions
const hasPermission = (currentUserRole, moduleaccess, moduleName) => {
  return (
    currentUserRole === "ADMIN" ||
    currentUserRole === "SUPER_ADMIN" ||
    moduleaccess.includes(moduleName)
  );
};

const commonHeaderLinkLists = (t) => {
  // loggedin user details to get the role
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  // get the role and allow for admin or superadmin
  const currentUserRole = userInfo.role ? userInfo.role.slug : "USER";

  // get module access for roles other than admin and superadmin
  const moduleaccess = localStorage.getItem("moduleaccess");

  //console.log("currentUserRole", currentUserRole);

  // console.log("moduleaccess", moduleaccess);

  const headerTabs = [];

  const tabsConfig = [
    {
      module: "MOD_PATIENT_PRESCRIPTION",
      title: t("Prescriptions"),
      link: "/admin/patientmanagement/prescriptions",
    },
    {
      module: "MOD_PATIENT_CONDITION",
      title: t("Conditions"),
      link: "/admin/patientmanagement/conditions",
    },
    {
      module: "MOD_PATIENT_MEDICATION",
      title: t("Medications"),
      link: "/admin/patientmanagement/medications",
    },
    {
      module: "MOD_PATIENT_ALLERGY",
      title: t("Allergies"),
      link: "/admin/patientmanagement/allergies",
    },
    {
      module: "MOD_IMMUNIZATION_MANAGEMENT",
      title: t("Vaccinations"),
      link: "/admin/patientmanagement/immunizations",
    },
    {
      module: "MOD_RESULT_MANAGEMENT",
      title: t("Lab Tests"),
      link: "/admin/patientmanagement/results",
    },
    {
      module: "MOD_PATIENT_APPOINTMENT",
      title: t("Appointments"),
      link: "/admin/patientmanagement/appointments",
    },
    {
      module: "MOD_ELECTRONIC_PRESCRIPTION_MANAGEMENT",
      title: t("Electronic Prescriptions"),
      link: "/admin/patientmanagement/electronicprescriptions",
    },
    {
      module: "MOD_ORDER_MANAGEMENT",
      title: t("Orders"),
      link: "/admin/patientmanagement/orders",
    },
    {
      module: "MOD_CONSENT_MANAGEMENT",
      title: t("Consent"),
      link: "/admin/patientmanagement/consent",
    },
    {
      module: "MOD_NURSING_MANAGEMENT",
      title: t("Nursing"),
      link: "/admin/patientmanagement/nursing",
    },
    {
      module: "MOD_VITAL_MANAGEMENT",
      title: t("Vitals"),
      link: "/admin/patientmanagement/vitals/bloodpressure",
    },
  ];

  tabsConfig.forEach((tabConfig) => {
    if (hasPermission(currentUserRole, moduleaccess, tabConfig.module)) {
      headerTabs.push({ title: tabConfig.title, link: tabConfig.link });
    }
  });

  return headerTabs;
};

export { commonHeaderLinkLists };
